import React from 'react';
import PropTypes from 'prop-types';

export default class ButtonGroup extends React.Component
{
    static propTypes = {
        onChange: PropTypes.func
    };

    static defaultProps = {
        onChange: () => {}
    };

    render()
    {
        let elements = React.Children.toArray(this.props.children);

        if (elements.length < 1) {
            return null;
        }

        if (elements.length === 1) {
            return elements[0];
        }

        let lastElement = elements[elements.length - 1];

        elements = [cloneButton(elements[0], 'focus:z-10 rounded-l-md', this.props.onChange)]
            .concat(elements.slice(1, -1).map(
                element => cloneButton(element, 'focus:z-10 -ml-px', this.props.onChange)
            ))
            .concat(cloneButton(lastElement, 'focus:z-10 rounded-r-md -ml-px', this.props.onChange))

        return <div className="relative z-0 inline-flex shadow-sm">
            {elements}
        </div>;
    }
}

const cloneButton = (element, newClasses, onChange) => React.cloneElement(element, {
    grouped: true,
    className: `${newClasses} ${element.props.className}`,
    onClick: () => onChange(element.props.value)
});